export const ORGANIZATION_LABEL = 'Network';